import { observer } from 'mobx-react-lite'
import { LoadScript, GoogleMap, Polygon as Poly } from '@react-google-maps/api'
import { useCallback, useEffect, useRef, useState } from 'react'
import { DEFAULT_ZONE_COLOR, MapViewport } from '../../../front/settings/delivery/zones/zones.controller'

const polygonOptions = (color: string | null) => ({
    fillColor: color || DEFAULT_ZONE_COLOR,
    strokeColor: color || DEFAULT_ZONE_COLOR,
    fillOpacity: 0.3,
    strokeWeight: 3
})

const applyViewport = (map: any, viewport: MapViewport | null) => {
    if (!map || !viewport) return

    if (viewport.bounds) {
        const [[south, west], [north, east]] = viewport.bounds
        map.fitBounds({ south, west, north, east }, 40)
    } else if (viewport.center) {
        map.setCenter({ lat: viewport.center[0], lng: viewport.center[1] })
        if (viewport.zoom !== undefined) map.setZoom(viewport.zoom)
    }
}

export const GoogleMapZone = observer(({ controller, coordinates }: any) => {

    const [path, setPath] = useState([])
    // Центр и зум задаём только при создании карты — дальше она двигается через controller.viewport,
    // иначе react-google-maps будет возвращать карту к этим значениям при каждом рендере.
    const [initialView] = useState(() => ({
        center: { lat: controller.mapView.center[0], lng: controller.mapView.center[1] },
        zoom: controller.mapView.zoom
    }))

    const mapRef = useRef(null)
    const polygonRef = useRef(null)
    const listenersRef = useRef([])
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        setPath(coordinates)
    }, [coordinates])

    const viewport = controller.viewport

    useEffect(() => {
        applyViewport(mapRef.current, viewport)
    }, [viewport])

    // Как и у Яндекс-карты — нативный CSS-ресайз блока не сообщает об этом Google Maps,
    // карта продолжает рендериться в старом размере, пока ей явно не скажешь пересчитать.
    useEffect(() => {
        if (!containerRef.current || typeof ResizeObserver === 'undefined') {
            return
        }

        const observer = new ResizeObserver(() => {
            if (!mapRef.current) {
                return
            }
            // @ts-ignore
            const center = mapRef.current.getCenter()
            // @ts-ignore
            google.maps.event.trigger(mapRef.current, 'resize')
            // @ts-ignore
            if (center) mapRef.current.setCenter(center)
        })

        observer.observe(containerRef.current)

        return () => observer.disconnect()
    }, [])

    // Сообщаем контроллеру, что сейчас видно на карте — по этому месту создаётся новая зона.
    const onIdle = () => {
        const map: any = mapRef.current
        if (!map) return

        const center = map.getCenter()
        const bounds = map.getBounds()
        if (!center) return

        controller.setMapView(
            [center.lat(), center.lng()],
            map.getZoom(),
            bounds
                ? [
                    [bounds.getSouthWest().lat(), bounds.getSouthWest().lng()],
                    [bounds.getNorthEast().lat(), bounds.getNorthEast().lng()]
                ]
                : null
        )
    }

    const onLoadMap = (map: any) => {
        mapRef.current = map
        // Зоны/геолокация могли прийти раньше, чем загрузилась карта.
        applyViewport(map, controller.viewport)
    }

    const onEdit = useCallback(() => {
        if (polygonRef.current) {
            const nextPath = polygonRef.current
                // @ts-ignore
                .getPath()
                .getArray()
                .map((latLng: any) => {
                    return { lat: latLng.lat(), lng: latLng.lng() };
                });
            setPath(nextPath)
            // @ts-ignore
            let arr = []
            nextPath.map((el: any) => arr.push([el.lat, el.lng]))
            // @ts-ignore
            controller.onChangeGoogle(arr)
        }
    }, [setPath])

    const select = (id: number) => {
        setPath(controller.list.find((el: any) => el.id === id).coordinatesGoogle)
        controller.select(id)
    }

    const onLoad = useCallback(
        (polygon: any) => {
            polygonRef.current = polygon;
            const path = polygon.getPath();
            // listenersRef.current.push(
            //     // @ts-ignore
            //     // path.addListener("set_at", onEdit),
            //     // path.addListener("insert_at", onEdit),
            //     // path.addListener("remove_at", onEdit)
            // );
        },
        [onEdit]
    )

    const onUnmount = useCallback(() => {
        // @ts-ignore
        // listenersRef.current.forEach(lis => lis.remove());
        // polygonRef.current = null;
    }, [])

    return(
        <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
            <LoadScript
                id="script-loader"
                googleMapsApiKey="AIzaSyAsrW_1meOXr6ozX-__m-Iz1XQ4kUfH0mg"
                language="en"
                region="ru"
            >
                <GoogleMap
                    mapContainerClassName="App-map"
                    center={initialView.center}
                    zoom={initialView.zoom}
                    version="weekly"
                    onLoad={onLoadMap}
                    onIdle={onIdle}
                >
                    {controller.active.id > -1 &&
                        <Poly
                            editable
                            path={path}
                            onMouseUp={onEdit}
                            onLoad={onLoad}
                            onUnmount={onUnmount}
                            draggable
                            options={polygonOptions(controller.active.color)}
                        />
                    }
                    {controller.list.map((item: any) =>
                        <>
                            {controller.active.id !== item.id &&
                                <Poly
                                    path={item.coordinatesGoogle}
                                    onClick={() => select(item.id)}
                                    options={polygonOptions(item.color)}
                                />
                            }
                        </>
                    )}
                </GoogleMap>
            </LoadScript>
        </div>
    )
})
